import React from 'react';
import {List, Avatar, Button, Skeleton} from 'antd';
import ListItem from "./ListItem";
import superagent from 'superagent';
import json_data from "../mock";

const prod = 'www.scewin.cn'
const dev = 'localhost:8082'
const env = prod;
const url = `http://${prod}/star/repos`;

const count = 3;

class LoadMoreList extends React.Component {
    state = {
        initLoading: true,
        loading: false,
        data: [],
        list: [],
    };

    componentDidMount() {
        this.getData(res => {
            this.setState({
                initLoading: false,
                data: res.data.content,
                list: res.data.content,
            });
        });
    }

    getData = callback => {
        if (!env == prod) {
            callback(json_data);
        } else {
            superagent.get(url)
                .query({
                    page: this.state.list / 20,
                    size: 20,
                })
                .end((err, res) => {
                    // Calling the end function will send the request
                    callback(res.body);
                });
        }
    };

    onLoadMore = () => {
        this.setState({
            loading: true,
            list: this.state.data.concat([...new Array(count)].map(() => ({loading: true, name: {}}))),
        });
        this.getData(res => {
            const data = this.state.data.concat(res.data.content);
            this.setState(
                {
                    data,
                    list: data,
                    loading: false,
                },
                () => {
                    // Resetting window's offsetTop so as to display react-virtualized demo underfloor.
                    // In real scene, you can using public method of react-virtualized:
                    // https://stackoverflow.com/questions/46700726/how-to-use-public-method-updateposition-of-react-virtualized
                    window.dispatchEvent(new Event('resize'));
                },
            );
        });
    };

    render() {
        const {initLoading, loading, list} = this.state;
        const loadMore =
            !initLoading && !loading ? (
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: 12,
                        height: 32,
                        lineHeight: '32px',
                    }}
                >
                    <Button onClick={this.onLoadMore}>加载更多</Button>
                </div>
            ) : null;

        return (
            <List
                className="demo-loadmore-list"
                loading={initLoading}
                itemLayout="horizontal"
                loadMore={loadMore}
                dataSource={list}
                renderItem={item => (
                    <ListItem item={item}/>
                )}
            />
        );
    }
}

export default LoadMoreList;
